import React from 'react';

interface GhgMetricCardProps {
    label: string;
    value: string;
    /** Rendered after the value, e.g. the tCO2e unit or a percent sign. */
    unit?: React.ReactNode;
    /** The filled, emphasised card — used for the headline figure. */
    primary?: boolean;
    /** The pale-yellow card used for a scenario's total reduction. */
    highlight?: boolean;
}

export default function GhgMetricCard(props: GhgMetricCardProps) {
    const modifier = props.primary
        ? ' ghg-metric--primary'
        : (props.highlight ? ' ghg-metric--highlight' : '');

    return (
        <div className={'ghg-metric' + modifier}>
            <div className="ghg-metric__label">{props.label}</div>
            <div className="ghg-metric__value">
                {props.value}
                {props.unit ? <span className="ghg-metric__unit">{props.unit}</span> : null}
            </div>
        </div>
    );
}
